/* eslint-disable camelcase */
/**
 * @typedef {import('../main').default} BtoApp
 */

import { throttle } from '@bto-services/utils';
import { userLoggedIn } from '@bto-services/user';
/**
 * Aspire specific typedefs for all available methods and details check
 * https://jira.btobet.com/browse/SBFE-3281
 * @typedef {object} AspireSessionUpdate
 * @property {'Login'|'Logout'|'NoSession'} Status
 * @property {string} [PlayerID]
 * @property {string} [SessionToken]
 * @property {string} [EncryptedUserID]
 * @property {string} [CountryCode]
 * @property {string} CurrencyCode
 */

/**
 * Aspire service class
 * containing all Aspire specific logic
 */
export default class AspireService {
	static ngClicked = 5;
	static ngInterval;
	static throttledSessionClick = throttle(() => {
		this.ngClicked = 5;
	}, 300);
	/**
	 * Listen to session updates and auth player accordingly
	 * @param {BtoApp} btoApp - main vue app
	 * @returns {()=>void|void} - return unwatch function if we initialized onSessionUpdate
	 * otherwise return undefined
	 */
	static onSessionUpdate() {
		try {
			// Check if supported locale, if not this will throw an error
			let culture = APP_SETTINGS.formatting.locale || APP_SETTINGS.player.language;
			Intl.DateTimeFormat.supportedLocalesOf([culture]);
			if (APP_SETTINGS.formatting.locale) {
				APP_SETTINGS.locale = APP_SETTINGS.formatting.locale;
			}
		} catch (error) {
			// If player language is non standard locale, try to get the locale from html if present or default to currencyCulture
			APP_SETTINGS.locale = document.getElementsByTagName('html')[0].lang || APP_SETTINGS.currencyFormat.currencyCulture;
		}
	}

	/**
	 * Set the keep alive session interval if on aspire/neogames portals
	 * Call this method in main.js on mounted
	 */
	static setKeepAlive() {
		const intervalTime = +APP_SETTINGS.settings.ngSessionInterval;
		if (intervalTime && window['ng_fw'] && window['ng_fw'].keepAlive) {
			document.body.addEventListener('click', this.throttledSessionClick);
			this.ngInterval = setInterval(() => {
				if (this.ngClicked <= 0 || !userLoggedIn()) {
					return;
				}
				this.ngClicked -= 1;
				window['ng_fw'].keepAlive();
			}, intervalTime * 1000 * 60);
		}
	}

	/**
	 * Remove the keep alive session interval if on aspire/neogames portals
	 * Call this method in main.js on destroyed
	 */
	static removeKeepAlive() {
		document.body.removeEventListener('click', this.throttledSessionClick);
		if (this.ngInterval) {
			clearInterval(this.ngInterval);
		}
	}
}
